import { createFileRoute } from "@tanstack/react-router";
import { AssessmentReport } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/assessment/report/$sessionId")({
  head: () => {
    const head = seoHead({ title: "Know Your Child — Your Report", description: "Understand your child's everyday preferences with clear, educational insights and practical parenting support.", noindex: true });
    return { ...head, meta: head.meta.filter((meta) => !["og:image", "og:image:type", "og:image:width", "og:image:height", "twitter:image"].includes(meta.property ?? meta.name ?? "")) };
  },
  component: AssessmentReport,
});
